import axios from 'axios';
import config from '../config';
import httpArcheo from "../helpers/http-archeo";
import removeCircularReferences from "../helpers/utils/removeCircularReferences";


export const getRaccolte = async (filter) => {
  let path = `/api/private/v3/raccolta/get?`;
  filter.forEach((f) => {
    if(f.value) path += `${f.key}=${f.value}&`;
  });
  try {
    const response = await httpArcheo.get(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getRaccolta = async (id) => {
  const path = `/api/private/v3/raccolta/get/${id}`;
  try {
    const response = await httpArcheo.get(path);
    return response?.data?.raccolta;
  } catch (err) {
    throw err;
  }
};

export const createRaccolta = async (data) => {
  try {
    const sanitizedData = removeCircularReferences(data);
    const response = await httpArcheo.post("/api/private/v3/raccolta/save", sanitizedData);
    return response?.data;
  } catch (err) {
    throw err;
  }
};


export const updateRaccolta = async (data) => {
  try {
    const sanitizedData = removeCircularReferences(data);
    const response = await httpArcheo.put("/api/private/v3/raccolta/update", sanitizedData);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteRaccolta = async (id) => {
  const path = `/api/private/v3/raccolta/delete/${id}`;
  try {
    const response = await httpArcheo.delete(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};